var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudFilled64(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "64px",
    width: "64px",
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 256.00 256.00",
    xmlSpace: "preserve",
    stroke: "#000000",
    strokeWidth: 1.7920000000000003,
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.4,116.8c-0.4,0-0.8,0.1-1.2,0.1c0.2-1.9,0.3-3.8,0.3-5.7c0-32.6-26.4-59-59-59c-29.8,0-54.4,22.1-58.3,50.8 c-4-1.3-8.1-2.1-12.4-2.1c-22.4,0-40.6,18.2-40.6,40.6c0,0.2,0.1,0.4,0.1,0.5c-1.8-0.3-3.7-0.5-5.6-0.5c-16,0-28.8,12.9-28.8,28.7 s12.8,28.7,28.7,28.7c0,0,175.5-0.9,176.7-0.9c22.4,0,40.6-18.2,40.6-40.6C251,135,232.8,116.8,210.4,116.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudFilled64);
export default __webpack_public_path__ + "static/media/cloudFilled64.0f72251dcced8885c9bbe650e0e346ac.svg";
export { ForwardRef as ReactComponent };